import { reactive } from 'vue';
import { io } from 'socket.io-client';
import { useAuthStore } from '@/stores/auth-store';
import { storeToRefs } from 'pinia';
import { useChatStore } from '@/stores/chat-store';
import { BASE_URL } from '@/utils/constants/api-constants';

export const initSocket = () => {
  interface State {
    connected: boolean;
    fooEvents: any[];
    barEvents: any[];
  }

  const state: State = reactive({
    connected: false,
    fooEvents: [],
    barEvents: [],
  });

  const connectSocket = async () => {
    const { setMessages, setNewMessage, setLoadMoreMessages } = useChatStore();
    const { socket, isSomeoneInChat } = storeToRefs(useChatStore());

    const { token } = storeToRefs(useAuthStore());
    const tokenValue = token.value.substring(7);

    const URL: string = `wss://${BASE_URL.CHAT}`;

    socket.value = io(URL, {
      auth: {
        token: tokenValue,
        lang: navigator.language || 'en',
      },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 3000,
    });

    socket.value.on('connect_error', (err: any) => {
      console.error(':x:Error en la conexión:', err.message);
    });

    socket.value.on('b_error', (err: any) => {
      console.error(':x:Error:', err.message);
    });

    socket.value.on('connect', () => {
      console.log('Connected to socket');
      state.connected = true;
    });

    socket.value.on('b_chat_messages', (args: any) => {
      isSomeoneInChat.value = args.data.isSomeoneInChat;
      setMessages(args.data);
    });

    socket.value.on('b_user_in_chat', (args: any) => {
      isSomeoneInChat.value = args.status === 'connected';
    });

    socket.value.on('b_user_leave_chat', (args: any) => {
      isSomeoneInChat.value = args.status === 'disconnected' ? false : true;
    });

    socket.value.on('b_unread_messages', (args: any) => {
      setNewMessage(args);
    });

    socket.value.on('b_new_message', (args: any) => {
      setNewMessage(args);
    });

    socket.value.on('b_more_chat_messages', (args: any) => {
      setLoadMoreMessages(args);
    });

    socket.value.connect();
  };

  return { state, connectSocket };
};
